import React, {useEffect, useRef, useState} from 'react';
import {useNavigate} from "react-router-dom";
import {Button, Card, Col, Empty, Form, Row} from 'antd';
import {SActionBtn, SGeneralForms, SLowcodeList, STableActions} from "shj-components";
import dayjs from "dayjs";

import {getFileUrlPrefix} from "@/services";
import {formatEmnOfSign} from "@/services/homeService.ts";
import {addCallBackLogFn} from '../formModels/addCallBackLog';
import {addchargePersonFn} from '../formModels/addChargePerson';
import {addOrdercreateDisposeLogFn} from '../formModels/addOrdercreateDisposeLog';
import {modalAddWorkOrderFn} from '../formModels/addWorkOrder';
import {modalRemindWorkerOrderrFn} from '../formModels/remindWorkerOrder';
import {modalWorkerOrderBackFn} from '../formModels/workerOrderBack';
import {AnewOpenWorkerOrder, WorkerOrderAccept} from "@/pages/vip/components/popconfirmBtn";
import {checkVipPicturePre} from "@/pages/homePage/components/taskList/components/workDetail.tsx";
import {
  getTicketsCallbackLog,
  getTicketsDisposeLog,
  getTicketsListPage,
  getTicketsListPageByIssue, ticketsOperateLog
} from "@/services/customerServices.ts";
import {apiData2Table} from "@/utils/data.ts";
import styles from './index.module.less'
// 工单列表
export function OrderList(props: any) {
  const navigate = useNavigate()
  const {issueId, id, formOnly} = props;
  const tableRef = useRef<any>();
  const columns = [
    {
      title: '工单编号',
      dataIndex: 'code',
      width: 120,
    },
    {
      title: '处理人',
      dataIndex: 'disposeVo',
      render: (v) => v?.name,
      width: 100,
    },
    {
      title: '责任人',
      dataIndex: 'chargeVo',
      render: (v) => v?.name,
      width: 100,
    },
    {
      title: '所属门店',
      dataIndex: 'companyName',
      width: 100,
    },
    {
      title: '状态',
      dataIndex: 'statusDisplay',
      width: 100,
    },
    {
      title: '创建时间',
      dataIndex: 'createdTime',
      width: 160,
      itemType: 'dateTime'
    },
    {
      title: '操作',
      dataIndex: 'operation',
      key: 'operation',
      width: 100,
      fixed: 'right',
      align: 'center',
      render: (text: any, record: any) => {
        return actionTool(record);
      },
    },
  ];
  formOnly && columns.pop();
  // 刷新
  const reload = () => {
    const {
      current: {reload},
    } = tableRef;
    reload();
  };
  const actionTool = (record: any) => {
    const postCode = '' //getNowUserInfo('postCode');

    // 未受理 1
    // 已受理 2
    // 处理中 4
    // 已处理 5
    // 已退回 3
    // 已归档 6
    // 回访中 7
    // 草稿 0

    // 未受理/已受理/处理中：详情、催办；
    // 已处理：详情、重新打开；
    // 回访中/已退回：详情、编辑、派单；
    // 草稿：详情、编辑
    // 已归档：详情；
    return <>
      <STableActions>
        <SActionBtn
            primary
            onClick={() => {
              navigate(
                  '/issues/pendingList/detail/' + record.id + '/' + issueId + '/' + record.companyCode,
              );
            }}
        >
          详情
        </SActionBtn>
        {(record.status == 3 || record.status == 0 || record.status == 7) && ['A1070', 'A0026'].includes(postCode) && (
            <SActionBtn
                primary
                onClick={() => {
                  modalAddWorkOrderFn({
                    fn: () => {
                      reload();
                    },
                    isEdited: true,
                    companyCode: record.companyCode,
                    // workOrderObj: record,
                    issueId: record.issueId, //问题id
                    id: record.id, //问题id
                  });
                }}
            >
              编辑
            </SActionBtn>
        )}
        {record.status == 5 && postCode == 'A1070' && (
            // 重新打开
            <AnewOpenWorkerOrder id={record.id} fn={reload}></AnewOpenWorkerOrder>
        )}
        {record.status == 1 && (record.isDisposePerson || record.isChargePerson || record.isCopyPerson) && (
            <>
              {/* 受理 */}
              <WorkerOrderAccept id={record.id} fn={reload}></WorkerOrderAccept>
              <SActionBtn
                  onClick={() => {
                    modalWorkerOrderBackFn({
                      fn: () => {
                        reload();
                      },
                      id: record.id,
                    });
                  }}
              >
                退回
              </SActionBtn>
            </>
        )}

        {(record.status == 1 || record.status == 2 || record.status == 4) && ['A1070', 'A0026'].includes(postCode) && (
            <SActionBtn
                onClick={() => {
                  modalRemindWorkerOrderrFn({
                    fn: () => {
                      reload();
                    },
                    id: [record.id], //工单id
                  });
                }}
            >
              催办
            </SActionBtn>
        )}
      </STableActions>
    </>
  };

  const fetchList = async () => {
    console.log('fetch--->',)
    // tableRef.current.updateDataSource([]);
    return new Promise(async (resolve, reject) => {
      try {
        getTicketsListPageByIssue(issueId).then(res => {
          resolve({records: res})
        })
      } catch (e) {
        reject({success: false});
      }
    });
  };

  const extension = {
    request: {fetchList}
  }
  return (
      <SLowcodeList
          ref={tableRef}
          searchMode={'group'}
          config={{columns, fieldControl: false, rowSelection: false}}
          {...extension}
      />
  );
}

// 处理结果 or 评价记录
export function OrderResult(props: any) {
  const {detailsInfo, flag} = props;
  const baseInfoConfig = [
    {
      isShowBottomBorder: false,
      formItem: [
        {
          name: 'disposeDate',
          label: '处理完成时间',
          type: 'date',
          spanCol: 24,
        },
        {
          name: 'statusDisplay',
          label: '处理结果',
          spanCol: 24,
        },
        {
          name: 'disposeResult',
          label: '处理结果描述',
          spanCol: 24,
        },
      ],
    },
  ];
  const baseInfoConfig1 = [
    {
      isShowBottomBorder: false,
      formItem: [
        {
          name: 'commentResultDisplay',
          label: '评价记录',
          spanCol: 24,
        },
      ],
    },
  ];
  return (
      <>
        {flag == 'result' ? (
            <SGeneralForms isDetail={true} configs={baseInfoConfig} detailsData={detailsInfo}/>
        ) : (
            <SGeneralForms isDetail={true} configs={baseInfoConfig1} detailsData={detailsInfo}/>
        )}
      </>
  );
}

// 未受理:1
// isCreatePerson  创建人
// isDisposePerson  处理人  添加责任人
// isChargePerson  责任人
// isCopyPerson 抄送人      添加责任人

// 已退回:3
// isCreatePerson  创建人    回访记录-新建
// isDisposePerson  处理人
// isChargePerson  责任人
// isCopyPerson 抄送人

// 已归档:6
// isCreatePerson  创建人
// isDisposePerson  处理人   处理记录-新建
// isChargePerson  责任人   处理记录-新建
// isCopyPerson 抄送人      处理记录-新建

// 处理中:4
// isCreatePerson  创建人
// isDisposePerson  处理人   处理记录-新建
// isChargePerson  责任人    处理记录-新建
// isCopyPerson 抄送人      处理记录-新建

// 已处理:5
// isCreatePerson  创建人
// isDisposePerson  处理人
// isChargePerson  责任人
// isCopyPerson 抄送人

// 回访中:7
// isCreatePerson  创建人    详情-修改分类进度
// isDisposePerson  处理人
// isChargePerson  责任人
// isCopyPerson 抄送人

// 已受理:2
// isCreatePerson  创建人
// isDisposePerson  处理人   处理记录-新建  添加责任人
// isChargePerson  责任人    处理记录-新建
// isCopyPerson 抄送人       处理记录-新建  添加责任人

// 草稿:0
// isCreatePerson  创建人
// isDisposePerson  处理人
// isChargePerson  责任人
// isCopyPerson 抄送人

// 工单详情
export const WorkDetail = (props: any) => {
  const {orderList, companyCode, issueId, id, formOnly, fn} = props;
  const [baseUrl, setBaseUrl] = useState<any>('');
  useEffect(() => {
    initFn();
  }, []);
  const initFn = async () => {
    const data = await Promise.all([getFileUrlPrefix()]);
    setBaseUrl(data[0]);
  };

  const baseInfoConfig = [
    {
      formItem: [
        {
          name: 'classifyStatus',
          label: '工单分类',
          spanCol: 6,
          children: <div>{orderList?.ticketsClassifyList?.map(item => item.classifyName)}</div>
        },
        {
          name: 'isCompanyCharge',
          label: '门店责任',
          spanCol: 6,
          customRender: () => {
            return (
                <Form.Item label="门店责任" name="">
                  <span style={{marginLeft: '10px', color: '#333333'}}>{orderList?.isCompanyCharge ? '是' : '否'}</span>
                </Form.Item>
            );
          },
        },
        {
          name: 'chargeDesc',
          label: '责任说明',
          spanCol: 12,
        },
        {
          name: 'firstLevelCopyPerson',
          label: '一级抄送人',
          spanCol: 6,
          children : <div>{orderList?.firstLevelCopyPersonList?.map(item => item.name)}</div>
        },
        {
          name: 'secondLevelCopyPerson',
          label: '二级抄送人',
          spanCol: 6,
          children : <div>{orderList?.firstLevelCopyPersonList?.map(item => item.name)}</div>
        },
        {
          name: 'threeLevelCopyPerson',
          label: '三级抄送人',
          spanCol: 6,
          children : <div>{orderList?.firstLevelCopyPersonList?.map(item => item.name)}</div>
        },
        {
          name: 'disposePerson',
          label: '处理人',
          spanCol: 6,
          children : <div>{orderList?.disposeVo?.name}</div>

        },
        {
          name: 'chargePerson',
          label: '责任人',
          spanCol: 6,
          children : <div>{orderList?.chargeVo?.name}</div>

        },
        {
          name: 'reOpenCount',
          label: '重新打开次数',
          spanCol: 6,
        },
        {
          name: 'description',
          label: '工单描述',
          spanCol: 12,
        },
        {
          name: 'files',
          label: '附件',
          spanCol: 24,
          customRender: () => {
            return filesRender();
          },
        },
      ],
    },
  ];
  const filesRender = () => {
    return (
        <Form.Item label="附件" name="drawDesc">
          {orderList?.files &&
              JSON.parse(orderList.files).map((v: any) => {
                return (
                    // <span style={{ marginLeft: '10px' }}>
                    //   <a href={v.path} target="_blank" rel="noopener noreferrer">
                    //     {v.name}
                    //   </a>
                    // </span>
                    <a href={checkVipPicturePre(baseUrl, v.path)} target="_blank" title={v.name}>
                      <img
                          style={{height: '60px', width: '60px', margin: '5px'}}
                          src={checkVipPicturePre(baseUrl, v.path)}
                          alt={v.name}
                      />
                    </a>
                );
              })}
        </Form.Item>
    );
  };
  const flagTextTender = (title: any, flag: any) => {
    return (
        <Form.Item label={title} name="">
          <span style={{marginLeft: '10px', color: '#333333'}}>{flag == 1 ? '是' : flag == 0 ? '否' : ''}</span>
        </Form.Item>
    );
  };
  return (
      <>
        {/*
      分公司责任false且责任人有值 --  处理记录可添加/不显示添加责任人按钮/分公司责任人：是；
      分公司责任false且责任人为空  --  处理记录不可添加/显示添加责任人按钮/分公司责任人：否；
      // 分公司责任是0或者1,不管责任人是否有值  --  处理记录可添加/不显示添加责任人按钮/分公司责任人：否或者是
    */}
        {!orderList?.chargeVo?.name && !orderList?.isCompanyCharge && formOnly && (
            <Button
                onClick={() => {
                  addchargePersonFn({

                    fn: () => {
                      fn && fn();
                    },
                    companyCode: companyCode,
                    issueId: issueId,
                    id: id,
                  });
                }}
            >
              添加责任人
            </Button>
        )}
        <SGeneralForms isDetail={true} configs={baseInfoConfig} detailsData={orderList}/>
      </>
  );
};
// 处理记录
export const DisposeLog = (props: any) => {
  const {woId, issueId, formOnly, dataDetail, fn} = props;
  const [detailsInfo, setDetailsInfo] = useState<any>();
  const [baseUrl, setBaseUrl] = useState<any>('');

  const disposeResult = [
    {code: 1, label: '继续跟进'},
    {code: 2, label: '处理完成'},
  ];
  useEffect(() => {
    initFn();
  }, []);
  const initFn = async () => {
    const data = await getFileUrlPrefix();
    setBaseUrl(data);
    getTicketsDisposeLog({ticketsId: woId}).then(res => {
      setDetailsInfo(res)
    })
  };
  return (
      <>
        {!formOnly && (
            <Button
                style={{margin: '0 8px'}}
                onClick={() => {
                  addOrdercreateDisposeLogFn({
                    fn: () => {
                      fn && fn();
                      initFn();
                    },
                    dataDetail: dataDetail,
                    id: woId,
                    issueId: issueId,
                  });
                }}
            >
              新建
            </Button>
        )}
        {detailsInfo?.length ? (
            detailsInfo.map((item: any, index: number) => {
              return (
                  <>
                    <div style={{
                      marginBottom: '10px',
                      padding: '10px 20px',
                      border: '1px solid #eee',
                      borderLeft: '3px solid #eee'
                    }}>
                      预计完结时间：{dayjs(item.overDate).format('YYYY-MM-DD HH:mm:ss')}
                    </div>
                    <Card
                        key={index}
                        headStyle={{padding: '0 12px'}}
                        bodyStyle={{
                          padding: '8px 10px',
                          backgroundColor: '#FAFAFA',
                          borderTop: '1px solid #f0f0f0'
                        }}
                        style={{marginBottom: 12, padding: '15px'}}
                        title={item.createDate ? dayjs(item.createDate).format('YYYY-MM-DD HH:mm:ss') : ''}
                        extra={<div>操作类型 :{item?.type || ' 处理记录'}</div>}
                        className={styles.peddingCard}
                    >
                      <Row>
                        <Col span={2}>处理人：</Col>
                        {/* <Col span={20}>{item.createBy}</Col> */}
                        <Col span={22}>{item.createdByName}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>所属门店：</Col>
                        <Col span={22}>{item.companyName}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>处理结果：</Col>
                        <Col span={22}>{item.disposeResultName}</Col>
                      </Row>
                      <Row>
                        {/*  */}
                        <Col span={2}>处理时间：</Col>
                        <Col span={22}>{dayjs(item.disposeDate).format('YYYY-MM-DD HH:mm:ss')}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>解决方案分类：</Col>
                        <Col span={22}>{item.solutionName}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>工单问题分类：</Col>
                        <Col span={22}>{item.classifyNameList?.join(", ")}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>处理内容：</Col>
                        <Col span={22}>{item.content}</Col>
                      </Row>
                      <Row>
                        <Col span={2}>附件：</Col>
                        <Col span={22}>
                          {item?.files &&
                              JSON.parse(item?.files).map((v: any, i: any) => {
                                return (
                                    <a
                                        href={checkVipPicturePre(baseUrl, v.path)}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        title={v.name}
                                    >
                                      <img
                                          style={{height: '60px', width: '60px', margin: '5px'}}
                                          src={checkVipPicturePre(baseUrl, v.path)}
                                          alt={v.name}
                                      />
                                    </a>
                                );
                              })}
                        </Col>
                      </Row>
                    </Card>
                  </>
              );
            })
        ) : (
            <Empty/>
        )}
      </>
  );
};
// 回访记录
export const CallBackLog = (props: any) => {
  const {workerOrderDetail, companyCode, woId, issueId, formOnly, fn} = props;
  const [detailsInfo, setDetailsInfo] = useState<any>();
  const backResult = [
    {code: 1, label: '归档'},
    {code: 2, label: '重新打开'},
    {code: 3, label: '作废归档'},
  ];

  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    getTicketsCallbackLog({ticketsId: woId}).then(res => {
      setDetailsInfo(res)
    })
  };
  return (
      <>
        {!formOnly && (
            <Button
                style={{margin: '0 8px'}}
                onClick={() => {
                  addCallBackLogFn({
                    fn: () => {
                      fn && fn();
                      initFn();
                    },
                    id: woId,
                    issueId: issueId,
                  });
                }}
            >
              新建
            </Button>
        )}
        {detailsInfo?.length ? (
            detailsInfo.map((item: any, index: number) => {
              return (
                  <Card
                      key={index}
                      headStyle={{padding: '0 12px'}}
                      bodyStyle={{padding: '8px 10px', backgroundColor: '#FAFAFA', borderTop: '1px solid #f0f0f0'}}
                      style={{marginBottom: 12}}
                      title={item.createdDate ? dayjs(item.createdDate).format('YYYY-MM-DD HH:mm:ss') : ''}
                      extra={<div>操作类型 :{item?.type || ' 回访记录'}</div>}
                  >
                    <Row>
                      <Col span={2}>回访时间：</Col>
                      <Col span={22}>{item.callBackDate ? dayjs(item.callBackDate).format('YYYY-MM-DD HH:mm:ss') : ''}</Col>
                    </Row>
                    <Row>
                      <Col span={2}>回访内容：</Col>
                      <Col span={22}>{item.content}</Col>
                    </Row>
                    <Row>
                      <Col span={2}>回访客服：</Col>
                      <Col span={22}>{item.createdByName}</Col>
                    </Row>
                    <Row>
                      <Col span={2}>回访结果：</Col>
                      <Col span={22}>{formatEmnOfSign(item.result, backResult)}</Col>
                    </Row>
                  </Card>
              );
            })
        ) : (
            <Empty/>
        )}
      </>
  );
};
// 退回记录
export const BackLog = (props: any) => {
  const {detailsInfo} = props;
  const backResult = [
    {code: 1, label: '责任归属错误'},
    {code: 2, label: '其他'},
  ];
  return detailsInfo?.backDate ||
  detailsInfo?.backClassifyId ||
  detailsInfo?.backDescription ||
  detailsInfo?.backUser ? (
      <Card
          key={'BackLog'}
          headStyle={{padding: '0 12px'}}
          bodyStyle={{padding: '8px 10px', backgroundColor: '#FAFAFA', borderTop: '1px solid #f0f0f0'}}
          style={{marginBottom: 12}}
          title={detailsInfo.backDate ? dayjs(detailsInfo.backDate).format('YYYY-MM-DD HH:mm:ss') : ''}
          extra={<div>操作类型 :{detailsInfo?.type || ' 退回记录'}</div>}
      >
        <Row>
          <Col span={4}>退回分类：</Col>
          <Col span={20}>{formatEmnOfSign(detailsInfo.backClassifyId, backResult)}</Col>
        </Row>
        <Row>
          <Col span={4}>退回原因：</Col>
          <Col span={20}>{detailsInfo.backDescription}</Col>
        </Row>
        <Row>
          <Col span={4}>退回人：</Col>
          <Col span={20}>{detailsInfo.backUserName}</Col>
        </Row>
      </Card>
  ) : (
      <Empty/>
  );
};
// 操作记录
export const OperateLog = (props: any) => {
  const {id, issueId, sysItem} = props;
  const [detailsInfo, setDetailsInfo] = useState<any>();
  useEffect(() => {
    initFn();
  }, []);

  const initFn = () => {
    ticketsOperateLog({
      params: {current: 1, pageSize: 100},
      data: {
        itemId: sysItem == 'WORKER_ORDER' ? id : issueId,
        sysItem: sysItem, // "ISSUE" "WORKER_ORDER"
      }
    })
        .then((resp) => {
          setDetailsInfo(resp.list);
        })
        .catch(() => {
        });
  };

  return (
      <>
        {detailsInfo?.length ? (
            detailsInfo.map((item: any, index: number) => {
              return (
                  <Card
                      key={index}
                      headStyle={{padding: '0 12px'}}
                      bodyStyle={{padding: '8px 10px', backgroundColor: '#FAFAFA', borderTop: '1px solid #f0f0f0'}}
                      style={{marginBottom: 12}}
                      title={item.createdTime ? dayjs(item.createdTime).format('YYYY-MM-DD HH:mm:ss') : ''}
                      extra={<div>操作类型 :{item?.operateTypeDesc || '  操作记录'}</div>}
                  >
                    <Row>
                      <Col span={4}>跟进人姓名：</Col>
                      <Col span={20}>{item.createdByName}</Col>
                    </Row>
                    <Row>
                      <Col span={4}>详情：</Col>
                      <Col span={20}>{item.seePhoneDesc}</Col>
                    </Row>
                    <Row>
                      <Col span={4}>电话类型：</Col>
                      <Col span={20}>{item.param1}</Col>
                    </Row>
                    <Row>
                      <Col span={4}>最近操作时间：</Col>
                      <Col span={20}>{item.lastUpdatedTime}</Col>
                    </Row>
                  </Card>
              );
            })
        ) : (
            <Empty/>
        )}
      </>
  );
};
